import { Component, OnInit } from '@angular/core';
import { GeneralService } from '../services/general.service';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
declare var $ : any;
@Component({
  selector: 'app-model-caracteristique',
  templateUrl: './model-caracteristique.component.html',
  styleUrls: ['./model-caracteristique.component.scss']
})
export class ModelCaracteristiqueComponent implements OnInit {
  constructor(private router:Router,private generalService :GeneralService){}
  caracteristiqueModel = {ecArtCarMod_Id : "",ecArtCarMod_Label:""};
  initCarectiristiqueModel;
  dataSource = new MatTableDataSource([]);
  row = null;
  disabled = false;
  azerty;// ne pas supprimer  
  displayedColumns=["ecArtCarMod_Id","ecArtCarMod_Label"];
  enregistrementTerminer = true
  disabledBtnSupprimer : boolean = false;
  ngOnInit() 
  {  
    if(this.generalService.userConnecter == "")
    {
      this.router.navigate([""]);
    }
    else
    {
      this.getInitCaracreristique();
      this.getListeCaracreristique();
    }  
    
  }
  getListeCaracreristique()
  {
    this.generalService.rechercheTable(this.generalService.urlListeModel).subscribe(data =>
    {
      this.enregistrementTerminer = true;
      this.dataSource =new MatTableDataSource(data); ;
    })
  }
  getInitCaracreristique()
  {
    this.generalService.rechercheTable(this.generalService.urlcaracteristiqueModel).subscribe(data =>
    {
      this.initCarectiristiqueModel = data;
    })
  }
  ajouter(f)
  {
    if(f.form.valid)
    {
      var testExist = this.dataSource.data.find(cat => {return cat.ecArtCarMod_Label == this.caracteristiqueModel.ecArtCarMod_Label})
      if(testExist == undefined)
      {
        this.initCarectiristiqueModel.ecArtCarMod[0].ecArtCarMod_Label = this.generalService.clone( this.caracteristiqueModel.ecArtCarMod_Label);
        //this.initCarectiristique.ecArtCarMod[0].ecArtCarMod_Id = this.generalService.clone( this.caracteristique.ecArtCarMod_Id);
        this.updateDB(this.initCarectiristiqueModel);
        var row = this.generalService.clone({ecArtCarMod_Id:this.caracteristiqueModel.ecArtCarMod_Id,ecArtCarMod_Label:this.caracteristiqueModel.ecArtCarMod_Label});
        this.dataSource.data.push(row);
        if(this.dataSource.data.length>5)
        {
          $("#tablecaracteristiques").addClass("tableClass")
        }
        else
        {
          $("#tableCaracteristiques").removeClass("tableClass")
        }
        this.dataSource = new MatTableDataSource(this.dataSource.data);
      }
      else 
        this.generalService.dialogSuccess("Veuillez saisir un nouveau modèle de caractéristique",false);
    }    
  }
  updateDB(ds)
  {
    this.enregistrementTerminer = false;
    this.generalService.enregisterTable(ds).subscribe(data => 
    {      
      this.generalService.dialogSuccess("Modéle de caractéristique enregister",true);
      this.getListeCaracreristique();
    },
    (err) =>
    {
      this.generalService.dialogSuccess("Modéle de caractéristique non enregisté",false);
    });
}
  selectRow(event, row) 
  {
    var els = document.getElementsByClassName("mat-row");
    Array.prototype.forEach.call(els, function(el)
    {      
      el.style="";
    });
    event.currentTarget.style="background-color: #a0bdf3;";
    this.row = row; 
  }
  applyFilter(filterValue: string) 
  {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
  modifier()
  {
    if(this.row != null)
    {
      var url = this.generalService.urlcaracteristiqueModel+"&val="+this.row.ecArtCarMod_Id;
      this.enregistrementTerminer = false;
      this.generalService.rechercheTable(url).subscribe(data => 
      {      
        data.ecArtCarMod[0].ecArtCarMod_Label = this.row.ecArtCarMod_Label;
        this.updateDB(data);
      },
      (err) =>
      {
        this.generalService.dialogSuccess("Modéle non enregistrer",false);
      });
    }
    else
      this.generalService.dialogSuccess("Veuiller selectionner une ligne",false);

    
  }
  supprimer()
  {
    if (this.row != null) 
    {
      var deleteFn = this.generalService.supprimer(this.row.ecArtCarMod_Id,"ecartcarmod");
      if(deleteFn != null)
      {
        this.enregistrementTerminer = false;
        this.disabledBtnSupprimer = true
        deleteFn.subscribe(data => 
        {
          this.getListeCaracreristique();
          this.generalService.dialogSuccess("Elément supprimer",true);
          this.enregistrementTerminer = true;
          this.disabledBtnSupprimer = false;
        },
        error =>
        {
            this.generalService.dialogSuccess("Elément non supprimé",false);
            this.enregistrementTerminer = true;
            this.disabledBtnSupprimer = false;
        });
      }
    }
  }
}
